import { render, staticRenderFns } from "./IconPageBreakPlus.vue?vue&type=template&id=1e920a19&"
import script from "./IconPageBreakPlus.vue?vue&type=script&lang=js&"
export * from "./IconPageBreakPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports